import { filterDiffFunction } from './chunk-WTGT4IDV.mjs';
import { selectCurrentSettingsData, getTimeFromUTCCore } from './chunk-67X7HZEW.mjs';
import { i18n_config_default } from './chunk-EJ2TIXJU.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/helpers/factories/settingsDifferences/diffPaymentsFactory.ts
var PaymentsGeneralFieldsLabels = /* @__PURE__ */ ((PaymentsGeneralFieldsLabels2) => {
  PaymentsGeneralFieldsLabels2["confirmDrawerStartingBalance"] = "confirmDrawerStartingBalance";
  PaymentsGeneralFieldsLabels2["dueExceedsPreAuth"] = "dueExceedsPreAuth";
  PaymentsGeneralFieldsLabels2["defaultPreAuthAmount"] = "defaultPreAuthAmount";
  PaymentsGeneralFieldsLabels2["automatedBatching"] = "automatedBatching";
  PaymentsGeneralFieldsLabels2["batchTime"] = "batchTime";
  PaymentsGeneralFieldsLabels2["printChecksOnCloseOrder"] = "printChecksOnCloseOrder";
  PaymentsGeneralFieldsLabels2["forceAllPaidOrdersToTipPending"] = "forceAllPaidOrdersToTipPending";
  PaymentsGeneralFieldsLabels2["requireManualClosingPostTip"] = "requireManualClosingPostTip";
  return PaymentsGeneralFieldsLabels2;
})(PaymentsGeneralFieldsLabels || {});
var PaymentsDualPricingFieldsLabels = /* @__PURE__ */ ((PaymentsDualPricingFieldsLabels2) => {
  PaymentsDualPricingFieldsLabels2["dualPricing"] = "dualPricing";
  PaymentsDualPricingFieldsLabels2["listPrice"] = "listPrice";
  PaymentsDualPricingFieldsLabels2["cardCashPrice"] = "cardCashPrice";
  return PaymentsDualPricingFieldsLabels2;
})(PaymentsDualPricingFieldsLabels || {});
var PaymentsTipSettingsFieldsLabels = /* @__PURE__ */ ((PaymentsTipSettingsFieldsLabels2) => {
  PaymentsTipSettingsFieldsLabels2["tipPayoutMethod"] = "tipPayoutMethod";
  PaymentsTipSettingsFieldsLabels2["tipDistribution"] = "tipDistribution";
  PaymentsTipSettingsFieldsLabels2["splitTipInterval"] = "splitTipInterval";
  PaymentsTipSettingsFieldsLabels2["shareBy"] = "shareBy";
  PaymentsTipSettingsFieldsLabels2["rolePoolContributors"] = "rolePoolContributors";
  PaymentsTipSettingsFieldsLabels2["rolePoolRecipients"] = "rolePoolRecipients";
  PaymentsTipSettingsFieldsLabels2["sharingRules"] = "sharingRules";
  PaymentsTipSettingsFieldsLabels2["defaultTipInput"] = "defaultTipInput";
  return PaymentsTipSettingsFieldsLabels2;
})(PaymentsTipSettingsFieldsLabels || {});
var PaymentsTenderTypesFieldsLabels = /* @__PURE__ */ ((PaymentsTenderTypesFieldsLabels2) => {
  PaymentsTenderTypesFieldsLabels2["acceptCashPayments"] = "acceptCashPayments";
  PaymentsTenderTypesFieldsLabels2["cashBackgroundColor"] = "cashBackgroundColor";
  PaymentsTenderTypesFieldsLabels2["cashTextColor"] = "cashTextColor";
  PaymentsTenderTypesFieldsLabels2["cashPrintMerchantCopy"] = "cashPrintMerchantCopy";
  PaymentsTenderTypesFieldsLabels2["cashPrintReceipt"] = "cashPrintReceipt";
  PaymentsTenderTypesFieldsLabels2["acceptCreditCardPayments"] = "acceptCreditCardPayments";
  PaymentsTenderTypesFieldsLabels2["creditCardBackgroundColor"] = "creditCardBackgroundColor";
  PaymentsTenderTypesFieldsLabels2["creditCardTextColor"] = "creditCardTextColor";
  PaymentsTenderTypesFieldsLabels2["creditCardAllowTips"] = "creditCardAllowTips";
  PaymentsTenderTypesFieldsLabels2["creditCardAutoConfirmTip"] = "creditCardAutoConfirmTip";
  PaymentsTenderTypesFieldsLabels2["creditCardPrintMerchantCopy"] = "creditCardPrintMerchantCopy";
  PaymentsTenderTypesFieldsLabels2["creditCardPrintReceipt"] = "creditCardPrintReceipt";
  PaymentsTenderTypesFieldsLabels2["creditCardPrintTip"] = "creditCardPrintTip";
  PaymentsTenderTypesFieldsLabels2["acceptHousePayments"] = "acceptHousePayments";
  PaymentsTenderTypesFieldsLabels2["houseBackgroundColor"] = "houseBackgroundColor";
  PaymentsTenderTypesFieldsLabels2["houseTextColor"] = "houseTextColor";
  PaymentsTenderTypesFieldsLabels2["houseAllowTips"] = "houseAllowTips";
  PaymentsTenderTypesFieldsLabels2["houseAutoConfirmTip"] = "houseAutoConfirmTip";
  PaymentsTenderTypesFieldsLabels2["housePrintMerchantCopy"] = "housePrintMerchantCopy";
  PaymentsTenderTypesFieldsLabels2["housePrintReceipt"] = "housePrintReceipt";
  PaymentsTenderTypesFieldsLabels2["housePrintTip"] = "housePrintTip";
  PaymentsTenderTypesFieldsLabels2["enableGiftCardPayments"] = "enableGiftCardPayments";
  PaymentsTenderTypesFieldsLabels2["enableEGiftIntegration"] = "enableEGiftIntegration";
  PaymentsTenderTypesFieldsLabels2["eGiftCardMerchantId"] = "eGiftCardMerchantId";
  PaymentsTenderTypesFieldsLabels2["eGiftCardLocationId"] = "eGiftCardLocationId";
  PaymentsTenderTypesFieldsLabels2["giftCardBackgroundColor"] = "giftCardBackgroundColor";
  PaymentsTenderTypesFieldsLabels2["giftCardTextColor"] = "giftCardTextColor";
  PaymentsTenderTypesFieldsLabels2["giftCardAllowTips"] = "giftCardAllowTips";
  PaymentsTenderTypesFieldsLabels2["giftCardAutoConfirmTip"] = "giftCardAutoConfirmTip";
  PaymentsTenderTypesFieldsLabels2["giftCardPrintMerchantCopy"] = "giftCardPrintMerchantCopy";
  PaymentsTenderTypesFieldsLabels2["giftCardPrintReceipt"] = "giftCardPrintReceipt";
  PaymentsTenderTypesFieldsLabels2["giftCardPrintTip"] = "giftCardPrintTip";
  return PaymentsTenderTypesFieldsLabels2;
})(PaymentsTenderTypesFieldsLabels || {});
var PaymentsCustomTendersFields = /* @__PURE__ */ ((PaymentsCustomTendersFields2) => {
  PaymentsCustomTendersFields2["sortPriority"] = "sortPriority";
  PaymentsCustomTendersFields2["active"] = "active";
  PaymentsCustomTendersFields2["name"] = "name";
  PaymentsCustomTendersFields2["allowsTips"] = "allowsTips";
  PaymentsCustomTendersFields2["autoConfirmTip"] = "autoConfirmTip";
  PaymentsCustomTendersFields2["printReceipt"] = "printReceipt";
  PaymentsCustomTendersFields2["printMerchantCopy"] = "printMerchantCopy";
  PaymentsCustomTendersFields2["printTipTotalLines"] = "printTipTotalLines";
  PaymentsCustomTendersFields2["backgroundColor"] = "backgroundColor";
  PaymentsCustomTendersFields2["textColor"] = "textColor";
  return PaymentsCustomTendersFields2;
})(PaymentsCustomTendersFields || {});
var CUSTOM_TENDERS_FIELDS_LABEL = {
  ["active" /* active */]: i18n_config_default.t(
    "app.modals.userDetailsDiffModal.basic.active"
  ),
  ["name" /* name */]: i18n_config_default.t("commonTexts.name"),
  ["sortPriority" /* sortPriority */]: i18n_config_default.t(
    "app.modals.registerModeDiffModal.general.modifierTags.sortPriority"
  ),
  ["allowsTips" /* allowsTips */]: i18n_config_default.t(
    "settingsModule.paymentsSettings.customTenders.allowsTips"
  ),
  ["autoConfirmTip" /* autoConfirmTip */]: i18n_config_default.t(
    "settingsModule.paymentsSettings.customTenders.autoConfirmTip"
  ),
  ["printReceipt" /* printReceipt */]: i18n_config_default.t(
    "settingsModule.paymentsSettings.customTenders.printReceipt"
  ),
  ["printMerchantCopy" /* printMerchantCopy */]: i18n_config_default.t(
    "settingsModule.paymentsSettings.customTenders.printMerchantCopy"
  ),
  ["printTipTotalLines" /* printTipTotalLines */]: i18n_config_default.t(
    "settingsModule.paymentsSettings.customTenders.printTipTotalLines"
  ),
  ["backgroundColor" /* backgroundColor */]: i18n_config_default.t(
    "app.modals.rolesDiffModal.basic.backgroundColor"
  ),
  ["textColor" /* textColor */]: i18n_config_default.t(
    "app.modals.rolesDiffModal.basic.textColor"
  )
};
var formatNewRolePoolTables = (difference) => {
  const PAYMENTS_SETTINGS_FIELD_LABELS = {
    ["rolePoolRecipients" /* rolePoolRecipients */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tipSettings.rolesReceivingFromPool"
    )
  };
  const fieldName = difference.path[0];
  const tableRows = [];
  Object.values(difference.rhs).forEach((value) => {
    tableRows.push({
      action: "add",
      id: value.id,
      changes: [
        {
          field: "roleId",
          value: value.roleId
        },
        {
          field: "amount",
          value: value.amount
        }
      ]
    });
  });
  return {
    field: fieldName,
    label: PAYMENTS_SETTINGS_FIELD_LABELS[fieldName],
    value: tableRows
  };
};
var formatNewSharingRulesTables = (difference) => {
  const PAYMENTS_SETTINGS_FIELD_LABELS = {
    ["sharingRules" /* sharingRules */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tipSettings.sharingRules"
    )
  };
  const fieldName = difference.path[0];
  const tableRows = [];
  Object.values(difference.rhs).forEach((value) => {
    tableRows.push({
      action: "add",
      id: value.id,
      changes: [
        {
          field: "contribution",
          value: value.contribution
        },
        {
          field: "contributorId",
          value: value.contributorId
        },
        {
          field: "recipients",
          value: value.recipients
        }
      ]
    });
  });
  return {
    field: fieldName,
    label: PAYMENTS_SETTINGS_FIELD_LABELS[fieldName],
    value: tableRows
  };
};
var returnCustomTendersLabel = (field) => {
  return CUSTOM_TENDERS_FIELDS_LABEL[field] || "";
};
var mapCallbackFn = (difference, state) => {
  const PAYMENTS_SETTINGS_FIELD_LABELS = {
    ["confirmDrawerStartingBalance" /* confirmDrawerStartingBalance */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.general.confirmDrawerStartingBalance"
    ),
    ["dueExceedsPreAuth" /* dueExceedsPreAuth */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.general.preAuthOptions.dueExceedsPreAuth"
    ),
    ["defaultPreAuthAmount" /* defaultPreAuthAmount */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.general.preAuthOptions.defaultPreAuthAmount"
    ),
    ["automatedBatching" /* automatedBatching */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.general.batchSettings.automatedBatching"
    ),
    ["batchTime" /* batchTime */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.general.batchSettings.batchTime"
    ),
    ["printChecksOnCloseOrder" /* printChecksOnCloseOrder */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.general.printChecksOnCloseOrder"
    ),
    ["forceAllPaidOrdersToTipPending" /* forceAllPaidOrdersToTipPending */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.general.forceAllPaidOrdersToTipPending"
    ),
    ["requireManualClosingPostTip" /* requireManualClosingPostTip */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.general.requireManualClosingPostTip"
    ),
    ["tipPayoutMethod" /* tipPayoutMethod */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tipSettings.tipPayoutMethod"
    ),
    ["tipDistribution" /* tipDistribution */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tipSettings.tipDistribution"
    ),
    ["defaultTipInput" /* defaultTipInput */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tipSettings.defaultTipInput"
    ),
    ["splitTipInterval" /* splitTipInterval */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tipSettings.splitTipInterval"
    ),
    ["shareBy" /* shareBy */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tipSettings.shareBy"
    ),
    ["acceptCashPayments" /* acceptCashPayments */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tenderTypes.acceptCashPayments"
    ),
    ["cashBackgroundColor" /* cashBackgroundColor */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tenderTypes.cashBackgroundColor"
    ),
    ["cashTextColor" /* cashTextColor */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tenderTypes.cashTextColor"
    ),
    ["cashPrintMerchantCopy" /* cashPrintMerchantCopy */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tenderTypes.cashPrintMerchantCopy"
    ),
    ["cashPrintReceipt" /* cashPrintReceipt */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tenderTypes.cashPrintReceipt"
    ),
    ["acceptCreditCardPayments" /* acceptCreditCardPayments */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tenderTypes.acceptCreditCardPayments"
    ),
    ["creditCardBackgroundColor" /* creditCardBackgroundColor */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tenderTypes.creditCardBackgroundColor"
    ),
    ["creditCardTextColor" /* creditCardTextColor */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tenderTypes.creditCardTextColor"
    ),
    ["creditCardAllowTips" /* creditCardAllowTips */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tenderTypes.creditCardAllowTips"
    ),
    ["creditCardAutoConfirmTip" /* creditCardAutoConfirmTip */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tenderTypes.creditCardAutoConfirmTip"
    ),
    ["creditCardPrintMerchantCopy" /* creditCardPrintMerchantCopy */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tenderTypes.creditCardPrintMerchantCopy"
    ),
    ["creditCardPrintReceipt" /* creditCardPrintReceipt */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tenderTypes.creditCardPrintReceipt"
    ),
    ["creditCardPrintTip" /* creditCardPrintTip */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tenderTypes.creditCardPrintTip"
    ),
    ["acceptHousePayments" /* acceptHousePayments */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tenderTypes.acceptHousePayments"
    ),
    ["houseBackgroundColor" /* houseBackgroundColor */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tenderTypes.houseBackgroundColor"
    ),
    ["houseTextColor" /* houseTextColor */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tenderTypes.houseTextColor"
    ),
    ["houseAllowTips" /* houseAllowTips */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tenderTypes.houseAllowTips"
    ),
    ["houseAutoConfirmTip" /* houseAutoConfirmTip */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tenderTypes.houseAutoConfirmTip"
    ),
    ["housePrintMerchantCopy" /* housePrintMerchantCopy */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tenderTypes.housePrintMerchantCopy"
    ),
    ["housePrintReceipt" /* housePrintReceipt */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tenderTypes.housePrintReceipt"
    ),
    ["housePrintTip" /* housePrintTip */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tenderTypes.housePrintTip"
    ),
    ["enableGiftCardPayments" /* enableGiftCardPayments */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tenderTypes.enableGiftCardPayments"
    ),
    ["enableEGiftIntegration" /* enableEGiftIntegration */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tenderTypes.enableEGiftIntegration"
    ),
    ["eGiftCardMerchantId" /* eGiftCardMerchantId */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tenderTypes.eGiftCardMerchantId"
    ),
    ["eGiftCardLocationId" /* eGiftCardLocationId */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tenderTypes.eGiftCardLocationId"
    ),
    ["giftCardBackgroundColor" /* giftCardBackgroundColor */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tenderTypes.giftCardBackgroundColor"
    ),
    ["giftCardTextColor" /* giftCardTextColor */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tenderTypes.giftCardTextColor"
    ),
    ["giftCardAllowTips" /* giftCardAllowTips */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tenderTypes.giftCardAllowTips"
    ),
    ["giftCardAutoConfirmTip" /* giftCardAutoConfirmTip */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tenderTypes.giftCardAutoConfirmTip"
    ),
    ["giftCardPrintMerchantCopy" /* giftCardPrintMerchantCopy */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tenderTypes.giftCardPrintMerchantCopy"
    ),
    ["giftCardPrintReceipt" /* giftCardPrintReceipt */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tenderTypes.giftCardPrintReceipt"
    ),
    ["giftCardPrintTip" /* giftCardPrintTip */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tenderTypes.giftCardPrintTip"
    ),
    ["dualPricing" /* dualPricing */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.dualPricing.title"
    ),
    ["listPrice" /* listPrice */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.dualPricing.listPrice.label"
    ),
    [`${"cardCashPrice" /* cardCashPrice */}-cash`]: i18n_config_default.t(
      "settingsModule.paymentsSettings.dualPricing.price.cash"
    ),
    [`${"cardCashPrice" /* cardCashPrice */}-card`]: i18n_config_default.t(
      "settingsModule.paymentsSettings.dualPricing.price.card"
    )
  };
  const fieldName = difference.path[0];
  if (fieldName === "defaultTipInput") {
    return {
      field: fieldName,
      value: difference.rhs,
      label: PAYMENTS_SETTINGS_FIELD_LABELS[fieldName],
      textValue: i18n_config_default.t(
        `settingsModule.paymentsSettings.tipSettings.${difference.rhs}`
      )
    };
  } else if (fieldName === "batchTime") {
    return {
      field: fieldName,
      value: difference.rhs,
      label: PAYMENTS_SETTINGS_FIELD_LABELS[fieldName],
      textValue: getTimeFromUTCCore(
        difference.rhs,
        state,
        false,
        false
      )
    };
  } else if (fieldName === "listPrice" /* listPrice */) {
    return {
      field: fieldName,
      value: difference.rhs,
      label: PAYMENTS_SETTINGS_FIELD_LABELS[fieldName],
      textValue: i18n_config_default.t(
        `settingsModule.paymentsSettings.dualPricing.listPrice.options.${difference.rhs}`
      )
    };
  } else if (fieldName === `${"cardCashPrice" /* cardCashPrice */}-cash`) {
    return {
      field: "cardCashPrice" /* cardCashPrice */,
      value: difference.rhs,
      label: PAYMENTS_SETTINGS_FIELD_LABELS[fieldName],
      textValue: `+${difference.rhs}%`
    };
  } else if (fieldName === `${"cardCashPrice" /* cardCashPrice */}-card`) {
    return {
      field: "cardCashPrice" /* cardCashPrice */,
      value: difference.rhs,
      label: PAYMENTS_SETTINGS_FIELD_LABELS[fieldName],
      textValue: `-${difference.rhs}%`
    };
  }
  return {
    field: fieldName,
    value: difference.rhs,
    label: PAYMENTS_SETTINGS_FIELD_LABELS[fieldName],
    textValue: difference.rhs
  };
};
var generateTipSettingsDifferences = (differences, state) => {
  const PAYMENTS_SETTINGS_FIELD_LABELS = {
    ["rolePoolContributors" /* rolePoolContributors */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tipSettings.rolesContributingToPool"
    ),
    ["rolePoolRecipients" /* rolePoolRecipients */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tipSettings.rolesReceivingFromPool"
    ),
    ["sharingRules" /* sharingRules */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.tipSettings.sharingRules"
    )
  };
  const tipSettingsDifferences = [];
  differences.forEach((difference) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const fieldName = difference.path[0];
    if ((fieldName === "rolePoolContributors" || fieldName === "rolePoolRecipients") && (difference.kind === "N" || difference.kind === "E") && ((_a = difference == null ? void 0 : difference.path) == null ? void 0 : _a.length) === 1 && difference.rhs) {
      tipSettingsDifferences.push(formatNewRolePoolTables(difference));
      return;
    }
    if (fieldName === "sharingRules" && (difference.kind === "N" || difference.kind === "E") && ((_b = difference == null ? void 0 : difference.path) == null ? void 0 : _b.length) === 1 && difference.rhs) {
      tipSettingsDifferences.push(formatNewSharingRulesTables(difference));
      return;
    }
    if ((fieldName === "rolePoolContributors" || fieldName === "rolePoolRecipients") && !(difference.kind === "N" && ((_c = difference == null ? void 0 : difference.path) == null ? void 0 : _c.length) === 1) && !(difference.kind === "E" && difference.rhs !== 0 && !difference.rhs)) {
      const rowId = difference.path[1];
      let poolDiff = tipSettingsDifferences.find(
        (diff) => diff.field === fieldName
      );
      if (!poolDiff) {
        poolDiff = {
          field: fieldName,
          label: PAYMENTS_SETTINGS_FIELD_LABELS[fieldName],
          value: []
        };
        tipSettingsDifferences.push(poolDiff);
      }
      if (difference.kind === "E") {
        const field = difference.path[2];
        const value = Number(difference.rhs);
        const isRowInPoolDiff = poolDiff.value.find((row) => row.id === rowId);
        if (!isRowInPoolDiff) {
          poolDiff.value.push({
            action: "update",
            id: rowId,
            changes: [{ field, value }]
          });
          return;
        }
        isRowInPoolDiff.changes.push({ field, value });
      } else if (difference.kind === "N") {
        poolDiff.value.push({
          action: "add",
          id: rowId,
          changes: [
            {
              field: "roleId",
              value: difference.rhs.roleId
            },
            {
              field: "amount",
              value: difference.rhs.amount
            }
          ]
        });
      } else if (difference.kind === "D") {
        poolDiff.value.push({
          action: "remove",
          id: rowId,
          changes: []
        });
      }
      return;
    }
    if (fieldName === "sharingRules" && !(difference.kind === "N" && ((_d = difference == null ? void 0 : difference.path) == null ? void 0 : _d.length) === 1) && !(difference.kind === "N" && ((_e = difference == null ? void 0 : difference.path) == null ? void 0 : _e.length) === 4) && !(difference.kind === "E" && difference.rhs !== 0 && !difference.rhs)) {
      const rowId = difference.path[1];
      let poolDiff = tipSettingsDifferences.find(
        (diff) => diff.field === fieldName
      );
      if (!poolDiff) {
        poolDiff = {
          field: fieldName,
          label: PAYMENTS_SETTINGS_FIELD_LABELS[fieldName],
          value: []
        };
        tipSettingsDifferences.push(poolDiff);
      }
      if (difference.kind === "E") {
        const field = difference.path[2];
        const value = field === "recipients" ? ((_g = (_f = state.settings.changeData.data.sharingRules) == null ? void 0 : _f[rowId]) == null ? void 0 : _g.recipients) || {} : Number(difference.rhs);
        const isRowInPoolDiff = poolDiff.value.find((row) => row.id === rowId);
        if (!isRowInPoolDiff) {
          poolDiff.value.push({
            action: "update",
            id: rowId,
            changes: [{ field, value }]
          });
          return;
        }
        isRowInPoolDiff.changes.push({ field, value });
      } else if (difference.kind === "N") {
        poolDiff.value.push({
          action: "add",
          id: rowId,
          changes: [
            {
              field: "contributorId",
              value: difference.rhs.contributorId
            },
            {
              field: "contribution",
              value: difference.rhs.contribution
            },
            {
              field: "recipients",
              value: difference.rhs.recipients
            }
          ]
        });
      } else if (difference.kind === "D") {
        poolDiff.value.push({
          action: "remove",
          id: rowId,
          changes: []
        });
      }
      return;
    }
    tipSettingsDifferences.push(mapCallbackFn(difference, state));
  });
  return tipSettingsDifferences;
};
var generateServiceChargeDifferences = (differences, state) => {
  let ServiceChargeFieldsLabels;
  ((ServiceChargeFieldsLabels2) => {
    ServiceChargeFieldsLabels2["active"] = "active";
    ServiceChargeFieldsLabels2["autoApply"] = "autoApply";
    ServiceChargeFieldsLabels2["serviceCharges"] = "serviceCharges";
    ServiceChargeFieldsLabels2["name"] = "name";
    ServiceChargeFieldsLabels2["charge"] = "charge";
    ServiceChargeFieldsLabels2["chargeType"] = "chargeType";
    ServiceChargeFieldsLabels2["assignTo"] = "assignTo";
    ServiceChargeFieldsLabels2["discount"] = "discount";
    ServiceChargeFieldsLabels2["orderTypes"] = "orderTypes";
    ServiceChargeFieldsLabels2["serviceAreas"] = "serviceAreas";
    ServiceChargeFieldsLabels2["minGuests"] = "minGuests";
    ServiceChargeFieldsLabels2["taxIds"] = "taxIds";
    ServiceChargeFieldsLabels2["posName"] = "posName";
  })(ServiceChargeFieldsLabels || (ServiceChargeFieldsLabels = {}));
  const SERVICE_CHARGE_FIELD_LABELS = {
    ["active" /* active */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.serviceChargeSettings.status"
    ),
    ["serviceCharges" /* serviceCharges */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.serviceChargeSettings.serviceCharges"
    ),
    ["name" /* name */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.serviceChargeSettings.name"
    ),
    ["charge" /* charge */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.serviceChargeSettings.charge"
    ),
    ["assignTo" /* assignTo */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.serviceChargeSettings.assignTo"
    ),
    ["discount" /* discount */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.serviceChargeSettings.discount"
    ),
    ["orderTypes" /* orderTypes */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.serviceChargeSettings.orderTypes"
    ),
    ["serviceAreas" /* serviceAreas */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.serviceChargeSettings.serviceAreas"
    ),
    ["minGuests" /* minGuests */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.serviceChargeSettings.minGuests"
    ),
    ["taxIds" /* taxIds */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.serviceChargeSettings.taxes"
    ),
    ["posName" /* posName */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.serviceChargeSettings.posName"
    ),
    ["chargeType" /* chargeType */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.serviceChargeSettings.chargeType"
    ),
    ["autoApply" /* autoApply */]: i18n_config_default.t(
      "settingsModule.paymentsSettings.serviceChargeSettings.autoApply"
    )
  };
  const serviceChargeDifferences = [];
  differences.forEach((difference) => {
    var _a, _b;
    const fieldName = difference.path[0];
    if (fieldName === "serviceCharges") {
      const rowId = difference.path[1];
      let poolDiff = serviceChargeDifferences.find(
        (diff) => diff.field === fieldName
      );
      if (!poolDiff) {
        poolDiff = {
          field: fieldName,
          label: SERVICE_CHARGE_FIELD_LABELS[fieldName],
          value: []
        };
        serviceChargeDifferences.push(poolDiff);
      }
      if (difference.kind === "E" || difference.kind === "A") {
        const field = difference.path[2];
        let value;
        if (field === "taxIds" || field === "serviceAreas" || field === "orderTypes") {
          value = ((_b = (_a = state.settings.changeData.data.serviceCharges) == null ? void 0 : _a[rowId]) == null ? void 0 : _b[field]) || [];
        } else {
          value = isNaN(difference.rhs) || typeof difference.rhs === "boolean" ? difference.rhs : Number(difference.rhs);
        }
        const isRowInPoolDiff = poolDiff.value.find((row) => row.id === rowId);
        if (!isRowInPoolDiff) {
          poolDiff.value.push({
            action: "update",
            id: rowId,
            changes: [{ field, value }]
          });
          return;
        }
        if ((field === "taxIds" || field === "serviceAreas" || field === "orderTypes") && isRowInPoolDiff.changes.find((change) => change.field === field)) {
          return;
        }
        isRowInPoolDiff.changes.push({ field, value });
      } else if (difference.kind === "N") {
        poolDiff.value.push({
          action: "add",
          id: rowId,
          changes: [
            {
              field: "active",
              value: difference.rhs.active
            },
            {
              field: "name",
              value: difference.rhs.name
            },
            {
              field: "charge",
              value: difference.rhs.charge
            },
            {
              field: "chargeType",
              value: difference.rhs.chargeType
            },
            {
              field: "autoApply",
              value: difference.rhs.autoApply
            },
            {
              field: "assignTo",
              value: difference.rhs.assignTo
            },
            {
              field: "discount",
              value: difference.rhs.discount
            },
            {
              field: "orderTypes",
              value: difference.rhs.orderTypes
            },
            {
              field: "serviceAreas",
              value: difference.rhs.serviceAreas
            },
            {
              field: "minGuests",
              value: difference.rhs.minGuests
            },
            {
              field: "taxIds",
              value: difference.rhs.taxIds
            },
            {
              field: "posName",
              value: difference.rhs.posName
            }
          ]
        });
      } else if (difference.kind === "D") {
        poolDiff.value.push({
          action: "remove",
          id: rowId,
          changes: []
        });
      }
      return;
    }
  });
  return serviceChargeDifferences;
};
var diffPaymentsFactory = (differences = [], state) => {
  const changeData = selectCurrentSettingsData(state);
  if (!differences) {
    return {
      general: [],
      tenderTypes: [],
      tipSettings: [],
      serviceChargeSettings: [],
      dualPricing: [],
      customTenders: []
    };
  }
  const generalFields = differences.filter((difference) => difference.path[0] in PaymentsGeneralFieldsLabels).map((difference) => mapCallbackFn(difference, state));
  const dualPricingFields = differences.filter((difference) => difference.path[0] in PaymentsDualPricingFieldsLabels).map((_difference) => {
    let difference = _difference;
    if (difference.path[0] === "cardCashPrice" /* cardCashPrice */) {
      const restOfPath = difference.path.slice(1);
      difference = __spreadProps(__spreadValues({}, difference), {
        path: [
          `${"cardCashPrice" /* cardCashPrice */}-${changeData.listPrice}`,
          ...restOfPath
        ]
      });
    }
    return mapCallbackFn(difference, state);
  });
  const tenderTypesFields = differences.filter((difference) => difference.path[0] in PaymentsTenderTypesFieldsLabels).map((difference) => mapCallbackFn(difference, state));
  const tipSettingsFields = differences.filter(
    (difference) => difference.path[0] in PaymentsTipSettingsFieldsLabels
  );
  let ServiceChargeFieldsLabels;
  ((ServiceChargeFieldsLabels2) => {
    ServiceChargeFieldsLabels2["active"] = "active";
    ServiceChargeFieldsLabels2["autoApply"] = "autoApply";
    ServiceChargeFieldsLabels2["serviceCharges"] = "serviceCharges";
    ServiceChargeFieldsLabels2["name"] = "name";
    ServiceChargeFieldsLabels2["charge"] = "charge";
    ServiceChargeFieldsLabels2["chargeType"] = "chargeType";
    ServiceChargeFieldsLabels2["assignTo"] = "assignTo";
    ServiceChargeFieldsLabels2["discount"] = "discount";
    ServiceChargeFieldsLabels2["orderTypes"] = "orderTypes";
    ServiceChargeFieldsLabels2["minGuests"] = "minGuests";
    ServiceChargeFieldsLabels2["taxIds"] = "taxIds";
    ServiceChargeFieldsLabels2["posName"] = "posName";
  })(ServiceChargeFieldsLabels || (ServiceChargeFieldsLabels = {}));
  const serviceChargesFields = differences.filter(
    (difference) => difference.path[0] in ServiceChargeFieldsLabels
  );
  return {
    general: generalFields,
    tenderTypes: tenderTypesFields,
    tipSettings: generateTipSettingsDifferences(tipSettingsFields, state),
    serviceChargeSettings: generateServiceChargeDifferences(
      serviceChargesFields,
      state
    ),
    dualPricing: dualPricingFields,
    customTenders: generateCustomTendersArray(differences, state)
  };
};
var generateCustomTendersArray = (diffArray, state) => {
  const changeData = selectCurrentSettingsData(state);
  const customTenders = [];
  const CUSTOM_TENDERS_FIELD = "customTenders";
  diffArray.forEach(
    (diff) => filterDiffFunction(
      diff,
      ({ diffLength }) => {
        if (diffLength === 1) {
          return;
        } else if (diffLength >= 2) {
          const customField = diff.path[0];
          if (diff.kind === "N") {
            let changes = Object.entries(
              diff.rhs
            ).map(([customTenderField, customTenderValue]) => {
              return {
                field: customTenderField,
                label: returnCustomTendersLabel(
                  customTenderField
                ),
                value: customTenderValue
              };
            });
            if (customField === CUSTOM_TENDERS_FIELD) {
              changes = changes.filter(
                (change) => change.field in PaymentsCustomTendersFields
              );
              customTenders.push({
                id: 0,
                tabletGeneratedId: diff.rhs.customTenderId,
                label: diff.rhs.name,
                action: "add",
                changes
              });
            }
          } else if (diff.kind === "D") {
            if (customField === CUSTOM_TENDERS_FIELD) {
              customTenders.push({
                id: Number(
                  diff.lhs.customTenderId
                ),
                tabletGeneratedId: diff.lhs.customTenderId,
                label: diff.lhs.name,
                action: "remove",
                changes: []
              });
            }
          } else if (diff.kind === "E") {
            const id = Number(diff.path[1]);
            const customNewDiff = {
              field: diff.path[2],
              label: returnCustomTendersLabel(
                diff.path[2]
              ) || "",
              value: diff.rhs
            };
            if (customField === CUSTOM_TENDERS_FIELD) {
              if (!customTenders.find(
                (orderSeatTag) => orderSeatTag.id === id && orderSeatTag.action === "update"
              )) {
                customTenders.push({
                  id,
                  tabletGeneratedId: id,
                  label: changeData.customTenders[id].name,
                  action: "update",
                  changes: [customNewDiff]
                });
              } else {
                for (const [i, orderSeatTag] of customTenders.entries()) {
                  if (orderSeatTag.id === id) {
                    customTenders[i].changes = [
                      ...orderSeatTag.changes,
                      customNewDiff
                    ];
                    break;
                  }
                }
              }
            }
          }
        }
      },
      returnCustomTendersLabel
    )
  );
  return customTenders;
};

export { PaymentsCustomTendersFields, PaymentsDualPricingFieldsLabels, PaymentsGeneralFieldsLabels, PaymentsTenderTypesFieldsLabels, PaymentsTipSettingsFieldsLabels, diffPaymentsFactory };
